window.keywordRedirects = {
  "gozney": "https://gwstore.com/collections/gozney",
  "outdoor kitchens": "https://gwstore.com/collections/outdoor-kitchens",
  "outdoor kitchen": "https://gwstore.com/collections/outdoor-kitchens",
  "ofyr": "https://gwstore.com/collections/ofyr-collection",
  "green egg": "https://gwstore.com/collections/big-green-egg",
  "big green egg": "https://gwstore.com/collections/big-green-egg",
  "broil king": "https://gwstore.com/collections/broil-king",
  "napoleon": "https://gwstore.com/collections/napoleon",
  "twin eagles": "https://gwstore.com/collections/twin-eagles",
  "ooni": "https://gwstore.com/collections/ooni-ovens",
  "kamado": "https://gwstore.com/collections/ceramic-grills",
  "kamados": "https://gwstore.com/collections/ceramic-grills",
  "gas grill": "https://gwstore.com/collections/gas-grills",
  "gas grills": "https://gwstore.com/collections/gas-grills",
  "pizza oven": "https://gwstore.com/collections/outdoor-pizza-ovens",
  "pizza ovens": "https://gwstore.com/collections/outdoor-pizza-ovens",
  "outdoor pizza oven": "https://gwstore.com/collections/outdoor-pizza-ovens",
  "outdoor pizza ovens": "https://gwstore.com/collections/outdoor-pizza-ovens",
  "kamado joe": "https://gwstorebestseller.com/collections/kamado-joe",
  "challenger designs": "https://gwstorebestseller.com/collections/challenger-designs?_pos=1&_psq=challenger+designs&_ss=e&_v=1.0",
  "challenger design": "https://gwstorebestseller.com/collections/challenger-designs?_pos=1&_psq=challenger+designs&_ss=e&_v=1.0",
  "chalenger designs": "https://gwstorebestseller.com/collections/challenger-designs?_pos=1&_psq=challenger+designs&_ss=e&_v=1.0",
  "chalenger design": "https://gwstorebestseller.com/collections/challenger-designs?_pos=1&_psq=challenger+designs&_ss=e&_v=1.0",
  "challenger": "https://gwstorebestseller.com/collections/challenger-designs?_pos=1&_psq=challenger+designs&_ss=e&_v=1.0",
  "nuke": "https://gwstorebestseller.com/collections/nuke",
  "ñuke": "https://gwstorebestseller.com/collections/nuke",
  "tromen": "https://gwstorebestseller.com/collections/tromen",
  "trueflame": "https://gwstorebestseller.com/collections/trueflame-collection",
  "true flame": "https://gwstorebestseller.com/collections/trueflame-collection"
};